// -*- mode: rjsx -*-
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';

import { Bar } from './Bar.jsx';
import { Menu } from './Menu.jsx';

import { setCurrentUser } from '..'; 

function HUD (props) {
    const dispatch = useDispatch();    
    const user = useSelector(state => {
        return state.hud ? state.hud.user : null;
    });

    
	useEffect((data) => {
		dispatch(setCurrentUser(window.pageVariables.user));
    }, [dispatch]);
    
	return (
        <>
          <Bar />
          <Menu />
        </>        
	);
}

export { HUD };
